export default __webpack_public_path__ + "static/media/63.5c70faa7.jpg";